import React, { Component } from "react";

import {Button, CloseButton} from '@learningblocks/shared-components';

import "./EndSimulation.scss";
import warningIcon from "./img/warning-modal-icon.svg";

export class EndSimulation extends Component {

  endSimulation = () => {

    this.props.closeModal();

    window.parent.postMessage({
      method: 'event',
      data: {type: 'requestClose'}
    }, '*');

    return false;
  };

  render() {
    return (
      <div className="modal-section endSimulationModal">
        <img alt="Warning icon." src={warningIcon} className="warningIcon" />
        <h3 className="heading">
          End Simulation
        </h3>
        <p className="endDescription">Are you sure you want to end this simulation?</p>
        <div className="modal-footer">
          <Button className='endSimulation' onClick={this.endSimulation}>
            End Simulation
          </Button>
        </div>
        <div className="modalCloseBtn">
          <CloseButton
            close={() => this.props.closeModal()}
          />
        </div>
      </div>
    );
  }
}
